module.exports = __webpack_public_path__ + "static/media/eerikkila-success-story-quote.32cabaa3.webp";